import { ServiceProviderType } from "@/types/index";
import { formatDate } from "@/utils/Functions";
import { FieldRow } from "../../../components/molecules/FieldsTable";
import { NotAvailable } from "../../Dashboard/RequestDetails/NotAvailable";
import { readableOwnershipStatus } from "../../Dashboard/RequestDetails/PropertyDetails";
import { readableLandlordType } from "../../NotifierForm/AccountForm/PropertyFields/OwnershipStatusField";
import { formatPropertyStatus, OwnershipStatus, PropertyStatus } from "../../../types/property";
import { MeterAccess } from "@/types/index";
import { PersonDetails } from "./PersonDetails";
import { readableAccountNextSteps } from "@/utils/accounts";

export const WaterAccount = ({
  account,
  serviceProviderType,
}: {
  account: any;
  serviceProviderType: ServiceProviderType;
}) => {
  return (
    <>
      <FieldRow label="Account number" value={account.accountNumber || <NotAvailable />} />
      <FieldRow
        label="Property address"
        value={
          <>
            {account?.property?.details?.address}
            <br />
            {account?.property?.details?.city}
            <br />
            {account?.property?.details?.postcode}
          </>
        }
      />
      <FieldRow label="Property status" value={formatPropertyStatus(account?.property?.status)} />

      {account?.property?.status === PropertyStatus.ExistingOccupier ? (
        <FieldRow
          label="Existing occupant"
          value={
            account?.property?.occupier?.id === "notifier" ? (
              "Myself"
            ) : (
              <PersonDetails person={account?.property?.occupier?.details} />
            )
          }
        />
      ) : (
        <>
          <FieldRow
            label="Occupied date"
            value={
              account?.property?.lastOccupiedDate
                ? formatDate(account?.property?.lastOccupiedDate)
                : "Date of death"
            }
          />
          <FieldRow
            label="Ownership status"
            value={readableOwnershipStatus(account?.property?.ownershipStatus)}
          />

          {account?.property?.ownershipStatus === OwnershipStatus.Rented && (
            <FieldRow
              label="Landlord"
              value={
                <>
                  {readableLandlordType(account?.property?.landlordType)}
                  <br />
                  {account?.property?.landlordName || ""}
                  <br />
                  {account?.property?.landlordAddress || ""}
                  <br />
                  {account?.property?.landlordPhoneNumber || ""}
                </>
              }
            />
          )}

          <FieldRow
            label="Responsible"
            value={
              account?.responsible?.id === "notifier" ? (
                "Myself"
              ) : (
                <PersonDetails person={account?.responsible?.details} />
              )
            }
          />
        </>
      )}

      {!!account?.responsibleRejectsArrears && (
        <FieldRow
          label="Arrears"
          value={
            <span>
              Existing occupant(s) is <b>not</b> willing to accept responsibility for arrears
            </span>
          }
        />
      )}

      {account?.meterAccess === MeterAccess.Yes ? (
        <>
          <FieldRow
            label="Last meter reading"
            value={account?.lastMeterReading || <NotAvailable />}
          />

          <FieldRow
            label="Date of the readings"
            value={account?.lastMeterReadingDate && formatDate(account?.lastMeterReadingDate)}
          />
        </>
      ) : account?.meterAccess === MeterAccess.Later ? (
        <FieldRow label="Meter reading" value="Will be provided later" />
      ) : account?.meterAccess === MeterAccess.No ? (
        <FieldRow label="Meter reading" value="No access to meter" />
      ) : account?.meterAccess === MeterAccess.NotMetered ? (
        <FieldRow label="Meter reading" value="Not metered" />
      ) : null}

      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(account?.nextStep, serviceProviderType)}
      />
    </>
  );
};
